import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

serviceWorkerRegistration.register({
  onSuccess: () => console.log('PWC Oneness App: App ready for offline use'),
  onUpdate: () => console.log('PWC Oneness App: New version available — refresh to update')
});
